import ajax from "./axios.config";
import utils from "./utils";
const statistical = {
    statisticContent: function (CMSId, NodeId) {
        let data = {
            "deviceType": "x86_64",
            "deviceId": "A6D2DD48-E3A8-4E1D-A9E3-40A4096B8FAC",
            "os": "iOS",
            "osVersion": "11.2",
            "app": "GSApp",
            "appVersion": "3.7.1",
            "request": {
                "cmsContentId": CMSId,
                "appNodeId": NodeId
            }
        };
        ajax.post("//appapi2click.gamersky.com/v1/statisticContent", JSON.stringify(data));
    },
    getTotalHits: function (id) {
        utils.AjaxJsonp("//click.gamersky.com/Common/GetTotalHits.aspx", {
            id: id
        })
    },
    getClubTopicTotalHits: function (clubContentId) {
        ajax.get("//click.gamersky.com/Common/GetClubTopicTotalHits.aspx", {
            clubContentId: clubContentId,
            source: "App"
        })
    },
    statisticAd: function (adId, operation) {
        let data = {
            "deviceType": "x86_64",
            "deviceId": "A6D2DD48-E3A8-4E1D-A9E3-40A4096B8FAC",
            "os": "iOS",
            "osVersion": "11.2",
            "app": "GSApp",
            "appVersion": "3.7.1",
            "request": {
                "adId": adId,
                "operation": operation,
            }
        };
        ajax.post("//appapi2click.gamersky.com/v1/statisticAd", JSON.stringify(data));
    },
    reportRecommend: function (recommendInfoId, type) { // type 0 曝光 1点击
        let data = {
            "deviceType": "x86_64",
            "deviceId": "A6D2DD48-E3A8-4E1D-A9E3-40A4096B8FAC",
            "os": "iOS",
            "osVersion": "11.2",
            "app": "GSApp",
            "appVersion": "3.7.1",
            "request": {
                "id": recommendInfoId,
                "type": type
            }
        };
        ajax.post("//appapi2click.gamersky.com/v5/reportRecommend", JSON.stringify(data));
    }
}
export default statistical;